<template>
    <div class="w-100">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <b-img-lazy
            v-if="imageUrl"
            :src="imageUrl"
            :alt="imageTitle"
            center 
            fluid
        ></b-img-lazy>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';

export default {
    name: 'GeneralTenantFileImage',  // used in new QualityIssue forms (state machine version)
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        slug: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            imageData: {},  // serialized image data from backend 
        }
    },
    computed: {
        imageUrl() {
            return this.imageData.url ?? '';
        },
        imageTitle() {
            return this.imageData.title ?? '';
        },
    },
    mounted() {
        this.getImage();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getImage() {
            this.loading = true;
            let resp; 
            try {
                resp = await suppliosApi.generalTenantFile.get_by_slug(this.slug);
            } catch (error) {
                // for these, if no response, that is likely no permission or not found... 
                // log error but just don't show anything, let everything collapse
                //this.apiErrorHandler(error);
                console.error(`Got error when trying to get image in GeneralTenantFileImage component with slug ${this.slug}`);
                console.error(error);
            }
            if (resp && resp.data) {
                this.imageData = resp.data;
            }
            this.loading = false;
        },
    }
}
</script>

<style>

</style>